import {
  removeNotification,
  SET_NOTIFICATION
} from "./../actions/notificationActions";
import { takeLatest, put } from "redux-saga/effects";
import { delay } from "redux-saga";

function* notification(action) {
  const { payload, meta } = action;
  const id = new Date().getMilliseconds();
  // enrich the original payload with an id
  const notification = {
    id,
    message: payload
  };
  // fire a new action with the enriched payload
  // note: the payload is an object
  yield put({
    type: SET_NOTIFICATION,
    payload: notification
  });

  // dispatch a clear action after a given time
  yield delay(4000);
  yield put(
    removeNotification({ notificationId: id, resource: meta.resource })
  );
}

export default function* notificationWatcher() {
  yield takeLatest(data => {
    if (data.meta) {
      return data.type.includes(SET_NOTIFICATION);
    }
  }, notification);
  // yield takeLatest(SET_NOTIFICATION, notification);
}



// WEBPACK FOOTER //
// ./src/redux/middleware/notificationMiddleware.js